import {App} from 'vue';
import Swal from 'sweetalert2';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        /**
         * SweetAlert2 instance
         * @type {typeof Swal}
         */
        $swal: typeof Swal;
    }
}

export default {
    /**
     * Vue plugin install function
     * @param {App} app - The Vue application instance
     */
    install: (app: App): void => {
        // Add SweetAlert2 instance to the global properties of the Vue app
        app.config.globalProperties.$swal = Swal;
    }
}